import Logger from 'core/utils/Logger'

export interface IParsedQbrDocumentSettings {
  selectedNetNdp?: string
  selectedCurrency?: string
  selectedOfferings?: string[]
  selectedPeriods?: Array<{ fYear?: number; fQuarters: number[] }>
}

export const parseQbrDocumentSettings = (
  settings: string | null | undefined
): IParsedQbrDocumentSettings => {
  if (!settings) {
    return {}
  }

  try {
    const parsed: unknown = JSON.parse(settings)

    if (typeof parsed !== 'object' || parsed === null) {
      return {}
    }

    const { SelectedNetNdp, SelectedCurrency, SelectedOfferings, Quarters } = parsed as {
      SelectedNetNdp?: string
      SelectedCurrency?: string
      SelectedOfferings?: string[]
      Quarters?: {
        Selected?: Array<{
          FQuarters?: Array<{ FQuarter?: number }>
        }>
      }
    }
    const selectedPeriods = Quarters?.Selected
    const mappedSelectedPeriods = Array.isArray(selectedPeriods)
      ? selectedPeriods.map((period) => ({
          fYear: (period as { FYear?: number }).FYear,
          fQuarters: Array.isArray(period.FQuarters)
            ? period.FQuarters.flatMap(({ FQuarter }) =>
                typeof FQuarter === 'number' ? [FQuarter] : []
              )
            : [],
        }))
      : undefined

    return {
      selectedNetNdp: SelectedNetNdp,
      selectedCurrency: SelectedCurrency,
      selectedOfferings: SelectedOfferings,
      selectedPeriods: mappedSelectedPeriods,
    }
  } catch (e) {
    Logger.error(`IFinancialCockpitQbrDocument.Settings: ${e}`)
    return {}
  }
}
